// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardSelectedOption\ApiTopicCardSelectedOption.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';
import { TopicCardOption, TopicCardOptionData, TopicCardOptionOptions } from 'data/models/TopicCardOption';

// TopicCardSelectedOptionData is the class that TopicCardSelectedOption serializes to/from
export interface TopicCardSelectedOptionData {
    Id : number;
    Url : string | null;
	
    Card : TopicCardData | null;
    Option : TopicCardOptionData | null;
    OptionId : number;
	
}

// TopicCardSelectedOptionOptions is the class which may be passed to the TopicCardSelectedOption constructor to define optional initial data values
export interface TopicCardSelectedOptionOptions {
    Id : number;
    Url? : string | null;
	
    Card? : TopicCardOptions | null;
    Option? : TopicCardOptionOptions | null;
    OptionId? : number;
	
}

export class TopicCardSelectedOption {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Card : DataSignal<TopicCard | null>;
    public Option : DataSignal<TopicCardOption | null>;
    public OptionId : DataSignal<number>;
	

    constructor();
    constructor(data : TopicCardSelectedOptionOptions);
    constructor(data: TopicCardSelectedOptionOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Card = S.value<TopicCard | null>(null);
        this.Option = S.value<TopicCardOption | null>(null);
        this.OptionId = jsonableObservable(S.value<number>(data && data.OptionId !== undefined ? data.OptionId : 0));
	    
    }

    static key(obj : TopicCardSelectedOption) {
        return obj.Id();
    }
    
    static dataKey(obj : TopicCardSelectedOptionOptions) {
        return obj.Id;
    }

    static update(obj : TopicCardSelectedOption, data : TopicCardSelectedOptionOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.OptionId !== undefined) obj.OptionId(data.OptionId);
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardSelectedOption.ts